export default __webpack_public_path__ + "static/media/docker.a2eecd96.svg";